module.exports = __webpack_public_path__ + "img/left-arrow.01375640.svg";